var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.428,
    height: 14.299,
    viewBox: "0 0 20.428 14.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-swimming-pool",
    "data-name": "Icon awesome-swimming-pool",
    d: "M19.917,14.507h-.511a2.692,2.692,0,0,1-1.79-.571,1.512,1.512,0,0,0-1.014-.45h-.52a1.512,1.512,0,0,0-1.014.45,2.689,2.689,0,0,1-1.79.571,2.692,2.692,0,0,1-1.79-.571,1.512,1.512,0,0,0-1.014-.45h-.52a1.512,1.512,0,0,0-1.014.45,2.689,2.689,0,0,1-1.79.571,2.692,2.692,0,0,1-1.79-.571,1.512,1.512,0,0,0-1.014-.45h-.52a1.512,1.512,0,0,0-1.014.45,2.689,2.689,0,0,1-1.79.571H.511A.511.511,0,0,0,0,15.017v1.021a.511.511,0,0,0,.511.511h.511a4.759,4.759,0,0,0,3.064-1.016A4.757,4.757,0,0,0,7.15,16.549a4.759,4.759,0,0,0,3.064-1.016,4.757,4.757,0,0,0,3.064,1.016,4.759,4.759,0,0,0,3.064-1.016,4.757,4.757,0,0,0,3.064,1.016h.511a.511.511,0,0,0,.511-.511V15.017A.511.511,0,0,0,19.917,14.507ZM7.15,13.485V10.421h6.128v3.064a1.749,1.749,0,0,0,1.1-.3,2.759,2.759,0,0,1,.945-.577V5.314a1.021,1.021,0,1,1,2.043,0v.511a.511.511,0,0,0,.511.511H18.9a.511.511,0,0,0,.511-.511V5.314a3.064,3.064,0,1,0-6.128,0V8.378H7.15V5.314a1.021,1.021,0,1,1,2.043,0v.511a.511.511,0,0,0,.511.511h1.021a.511.511,0,0,0,.511-.511V5.314a3.064,3.064,0,1,0-6.128,0v7.293a2.764,2.764,0,0,1,.945.577A1.746,1.746,0,0,0,7.15,13.485Z",
    transform: "translate(0 -2.25)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.bd806cc3b7e9c7caf4538cf2d4236d7e.svg";
export { ForwardRef as ReactComponent };